import List from './WorkerList';
import Create from './GuestWorkerCreate';
import Show from './WorkerShow';
import Edit from './WorkerEdit';
import WorkerIcon from '@mui/icons-material/Group';
import React from 'react';

const resourceName = 'Worker';
const resourceNamePlural = 'Workers';

const worker = {
    list: (props) => (
        <List resourceName={resourceName} resourceNamePlural={resourceNamePlural} {...props} />
    ),
    show: (props) => (
        <Show resourceName={resourceName} resourceNamePlural={resourceNamePlural} {...props} />
    ),
    edit: (props) => (
        <Edit resourceName={resourceName} resourceNamePlural={resourceNamePlural} {...props} />
    ),
    create: (props) => (
        <Create resourceName={resourceName} resourceNamePlural={resourceNamePlural} {...props} />
    ),
    icon: WorkerIcon,
};

export default worker;
